import { render, staticRenderFns } from "./CalcNotesTips.vue?vue&type=template&id=042f7122&scoped=true&"
var script = {}
import style0 from "./CalcNotesTips.vue?vue&type=style&index=0&id=042f7122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f7122",
  null
  
)

export default component.exports